import { PermissionEnum } from '@sr-sdks/api-sdk-axios';
import { lazy } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import { environmentName } from '../configuration';
import { capitalizeWords } from '../utils/helpers/common';
import { ProtectLazyLoadRoute } from './LazyLoadElement';

export const AdminRoutes: RouteObject[] = [
  {
    element: ProtectLazyLoadRoute(lazy(() => import('../layout/AdminLayout'))),
    children: [
      {
        path: 'embed-poc',
        element: ProtectLazyLoadRoute(
          lazy(() => import('../pages/Admin/EmbedPoc')),
        ),
        loader: () => ({
          // Internal roles only: it frames any MSR2 path, registration included.
          permissionRequired: [PermissionEnum.ViewStaffHomepage],
          title: 'APP-1880 Embed POC',
        }),
      },
      {
        path: 'docs',
        element: <Navigate replace to="../swagger" />,
        children: [{ path: ':selectedApi', element: <></> }],
      },
      {
        path: 'swagger',
        element: ProtectLazyLoadRoute(
          lazy(() => import('../pages/Admin/Swagger')),
        ),
        loader: () => {
          const data = {
            permissionRequired: [],
            title: 'Swagger',
          };

          if (environmentName !== 'production') {
            // In pre-production, allow authenticated users to access the docs page.
            // This is not a risk because the API calls still require a valid authorization token
            // And authorization happens on the server side
            return data;
          }

          return {
            ...data,
            permissionRequired: [
              PermissionEnum.EditDocuments,
              PermissionEnum.EditPermissions,
              PermissionEnum.ViewActivities,
            ],
          };
        },
        children: [
          {
            path: ':selectedApi',
            element: <></>,
            loader: ({ params }) => {
              return {
                title: `${capitalizeWords(
                  params.selectedApi || 'API',
                )} Service`,
              };
            },
          },
        ],
      },
    ],
  },
  /*
   * Sits beside the AdminLayout block rather than inside it, so the URL keeps
   * the /admin prefix while skipping DefaultLayoutV3 -- this page renders the
   * MSR3 shell itself.
   */
  {
    path: 'cognito-users',
    element: ProtectLazyLoadRoute(
      lazy(() => import('../pages/Admin/CognitoLookup')),
    ),
    loader: () => ({
      // Only internal roles hold this. ViewUsers would be wrong here: it is
      // workspace-scoped, and this page reads the whole user pool.
      permissionRequired: [PermissionEnum.ViewStaffHomepage],
      title: 'Cognito User Lookup',
    }),
  },
];
